import { newsStateName } from "./constants";

const getNewsState = (store) => store[newsStateName];
export const getUserNews = (s) => getNewsState(s).news;
